import React from 'react';

import FacebookIframe from './FacebookIframe';
import InstagramBlock from './InstagramBlock';
import TwitterBlock from './TwitterBlock';
import YoutubeIframe from './YoutubeIframe';
import t from '../../labels/labelling-utils';
import { SocialType } from '../../typings/common-types';
import { ComponentProps } from '../../typings/generic-component';
import { getSocialUrlParsed } from '../../utils/socials';
import { IClassNames, makeClassNames } from '../../utils/styles';
import BannerNoCookies from '../banner-no-cookies/banner-no-cookies';
import './social-embed.scss';

export interface ISocialEmbed extends ComponentProps {
  socialType?: SocialType;
  cookieAllowed?: boolean;
  src: string;
  width?: number | string;
  height?: number | string;
  isWebView?: boolean;
  instgrmCaption?: string;
}

export interface ISocialIframeProps {
  src: string;
  srcParsed?: string;
  width?: string | number;
  height?: string | number;
  caption?: string;
  cookieAllowed?: boolean;
}

const classNames = (socialType?: SocialType): IClassNames =>
  makeClassNames({
    SocialEmbed: ['social-embed', `social-embed--${socialType}`],
    SocialEmbedWebviewLink: 'social-embed__webview-link',
  });

const SocialEmbedBlock = ({
  className,
  socialType,
  src,
  cookieAllowed,
  width,
  height,
  instgrmCaption,
}: ISocialEmbed & { className: string }) => (
  <div className={className}>
    {socialType === 'twitter' && <TwitterBlock src={src} cookieAllowed={cookieAllowed} />}
    {socialType === 'facebook' && <FacebookIframe src={src} width={width} height={height} />}
    {socialType === 'youtube' && <YoutubeIframe src={src} />}
    {socialType === 'instagram' && <InstagramBlock src={src} caption={instgrmCaption} cookieAllowed={cookieAllowed} />}
  </div>
);

const SocialEmbed: React.FC<ISocialEmbed> = (props) => {
  const { socialType, cookieAllowed, src, isWebView } = props;
  const cn = socialType ? classNames(socialType) : {};

  const showBanner = !cookieAllowed;

  const srcParsed = getSocialUrlParsed(src, socialType);
  const socialLabel = socialType ? t(`social.embed.${socialType}.label`) : '';

  if (cookieAllowed === undefined) {
    return null;
  }

  if (showBanner) {
    return <BannerNoCookies socialType={socialType} />;
  }

  return isWebView ? (
    <div className={cn.SocialEmbedWebviewLink}>
      <a href={srcParsed}>{`${t('social.embed.go.to.post')} ${socialLabel}`}</a>
    </div>
  ) : (
    <SocialEmbedBlock className={cn.SocialEmbed} {...props} />
  );
};

export default React.memo(SocialEmbed);
